/*
html の data-theme (暗い版) を持ってよい頁。
公開の頁 (/code/pricing、/glossary、/news など) には暗い版の切り替えが無く、本文の札は暗い版の色を持たない。
html に data-theme="dark" が残ると、白い札のまま字だけ白くなって読めなくなる。
暗い版を持つ頁を足すときは、ここに接頭辞を足す。/ と /schools は自前の暗い面を持つので html の data-theme に頼らない
*/
/* /onboarding は登録のあとの初めの設定。頁が LuagateThemeProvider で本人の明暗を当てる */
const HTML_THEME_PREFIXES = ["/luagate", "/demo", "/dev", "/zukai-demo", "/skillmap/demo", "/onboarding"] as const;

export function ownsHtmlTheme(pathname: string): boolean {
  return HTML_THEME_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

/** 頁の移動で、持てない頁に入ったら html の data-theme を外す */
export function releaseHtmlThemeOutsideOwners(pathname: string, root: Pick<HTMLElement, "removeAttribute"> & Partial<Pick<HTMLElement, "hasAttribute">>): boolean {
  if (ownsHtmlTheme(pathname)) return false;
  // /luagate の外枠で描いている頁 (pages/shell/member-shell.layout.tsx) は、外枠が明暗を持つ
  if (root.hasAttribute?.("data-theme-owner")) return false;
  root.removeAttribute("data-theme");
  return true;
}
